<template>
  <div
    class="dialog-app-panel taskRule_wrap"
    :class="linkDialog ? 'dialog-show' : ''"
  >
    <appPanel
      class="app-panel"
      :isExpand="linkDialog"
      title="配置任务自动派发"
      @cancel="cancleChoose"
    >
      <el-form
        :model="configForm"
        ref="form"
        class="app-panel__form"
        label-width="100px"
        label-position="top"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="派发类型" prop="alarmTaskRuleType">
              <el-select
                style="width: 100%"
                v-model="configForm.alarmTaskRuleType"
                placeholder="请选择"
                @change="changeAlarmTaskRule"
              >
                <el-option
                  v-for="item in alarmTaskRuleTypes"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="rowScroll" v-if="configForm.alarmTaskRuleType == '1'">
          <el-col :span="24">
            <el-form-item label="选择工作组" prop="workGroupOrAccountList">
              <template>
                <div class="content-top-tree">
                  <div class="content-top-left">
                    <el-scrollbar class="scroll-bar">
                      <el-tree
                        class="tree-list"
                        ref="workGroupTree"
                        node-key="id"
                        :data="treeData"
                        :props="props"
                        :renderContent="renderContent"
                        :filter-node-method="filterNode"
                        :default-expand-all="true"
                        :default-checked-keys="defaultCheckedKeys"
                        show-checkbox
                      >
                      </el-tree>
                    </el-scrollbar>
                  </div>
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="configForm.alarmTaskRuleType == '2'" class="rowScroll">
          <el-col :span="24">
            <el-form-item label="选择保卫人员" prop="workGroupOrAccountList">
              <!-- 保卫人员选择面板 -->
              <template>
                <div class="groupContent">
                  <div class="content-top">
                    <div class="content-top-left">
                      <div class="title">可选人员</div>
                      <div class="content-main">
                        <el-input
                          placeholder="请输入人员"
                          v-model="account"
                          clearable
                          class="input-with-select"
                          style="padding: 10px"
                        >
                        </el-input>
                        <el-scrollbar class="scroll-bar">
                          <!-- <ul class="group-list"> -->
                            <el-tree
                              class="tree-list"
                              ref="tree"
                              node-key="id"
                              :data="treeData"
                              :props="props"
                              :renderContent="renderContent"
                              :filter-node-method="filterNode"
                              show-checkbox
                            >
                            </el-tree>
                          <!-- </ul> -->
                        </el-scrollbar>
                      </div>
                    </div>
                    <div class="content-top-middle">
                      <div style="text-align: center; margin-bottom: 30px">
                        <img
                          src="@src/common/assets/images/arrows_left.png"
                          @click="transferWorkGroupOrAccount('right')"
                          style="cursor: pointer"
                          alt=""
                        />
                      </div>
                      <div style="text-align: center">
                        <img
                          src="@src/common/assets/images/arrows_right.png"
                          @click="transferWorkGroupOrAccount('left')"
                          alt=""
                          style="cursor: pointer"
                        />
                      </div>
                    </div>

                    <div class="content-top-right">
                      <h4 class="title">已选人员</h4>
                      <div class="content-main">
                        <el-input
                          placeholder="请输入人员"
                          v-model="accountRight"
                          clearable
                          style="padding: 10px"
                          class="input-with-select"
                        >
                        </el-input>
                        <el-scrollbar class="scroll-bar">
                          <ul class="person-list">
                            <li
                              v-for="(item, index) in accountRight
                                ? selectedListFilter
                                : selectedList"
                              :key="index"
                              class="person"
                            >
                              <el-checkbox
                                v-model="item.checked"
                                @change="checkChange(item.checked, index)"
                              ></el-checkbox>
                              <span class="checked-name" :title="item.name">{{
                                item.name
                              }}</span>
                            </li>
                          </ul>
                        </el-scrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleChoose" type="info">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../../api";
import appPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      linkDialog: false,
      linkDialog2: false,
      ruleId: "",
      alarmTaskRuleCode: "",
      account: "",
      alarmTaskRuleTypes: [
        {
          value: "1",
          label: "指定中队",
        },
        {
          value: "2",
          label: "指定人员",
        },
      ],
      alarmTaskRuleType: "1",

      alarmTaskRulePersonList: [],
      props: {
        label: "name",
        id: "id",
        isLeaf: "isLeaf",
      },
      treeData: [],
      selectedList: [],
      // 授权表单数据
      configForm: {
        // 派发规则编号
        alarmTaskRuleCode: "",
        // 派发规则类型
        alarmTaskRuleType: "",
      },
      rules: {
        alarmTaskRuleType: [
          {
            required: true,
            message: "请选择派发类型",
            trigger: ["change", "blur"],
          },
        ],
      },
      rowInfo: {},
      defaultCheckedKeys: [],
      selectedListFilter: [],
      accountRight: "",
    };
  },
  watch: {
    account(val) {
      this.$refs.tree.filter(val);
    },
    accountRight(val) {
      if (val) {
        this.selectedListFilter = this.selectedList.filter((el) => {
          return el.name.indexOf(val) != -1;
        });
      } else {
        this.selectedListFilter = [];
      }
    },
  },
  computed: {},
  mounted() {},
  methods: {
    checkChange(data, index) {
      this.$forceUpdate();
    },
    open(item) {
      this.linkDialog = true;
      this.ruleId = item.ruleId;
      this.defaultCheckedKeys = [];
      this.alarmTaskRuleCode = item.alarmTaskRuleCode;
      // 修改的时候需要回填
      if (this.alarmTaskRuleCode && this.alarmTaskRuleCode != "") {
        // 获取查询派发规则配置信息
        const params = {
          alarmTaskRuleCode: this.alarmTaskRuleCode,
        };
        this.$fetch(api.device.queryAlarmTaskRule, params).then((res) => {
          let autoTaskRuleInfo = res.returnObj;
          this.alarmTaskRuleType = autoTaskRuleInfo.alarmTaskRuleType;
          this.alarmTaskRulePersonList =
            autoTaskRuleInfo.alarmTaskRulePersonList;
          this.configForm.alarmTaskRuleType = this.alarmTaskRuleType;
          this.queryOutWorkGroupOrAccount("init");
          if (this.configForm.alarmTaskRuleType == "1") {
            let keyIds = this.alarmTaskRulePersonList.map((item) => {
              return item.workGroupOrAccount;
            });
            this.$nextTick(() => {
              this.$refs.workGroupTree.setCheckedKeys(keyIds);
            });
          }
          this.queryInWorkGroupOrAccount();
        });
      } else {
        this.configForm.alarmTaskRuleType = this.alarmTaskRuleType;
        this.queryOutWorkGroupOrAccount("init");
      }
    },
    queryOutWorkGroupOrAccount(init) {
      this.treeData = [];
      this.selectedList = [];
      let url = api.device.querySecurityWorkGroup;
      let params = {};
      if (this.configForm.alarmTaskRuleType == "2") {
        url = api.device.queryAccountList;
        params = {
          accountType: "1",
          pageNo: 1,
          pageSize: 10000,
        };
      }
      this.$fetch(url, params).then((res) => {
        if (res.success) {
          if (res.returnObj) {
            const result = this.menusDataPro(res.returnObj, init);
            this.treeData = Object.freeze(result);
            this.treeData.forEach((item, index) => {
              this.selectedList.forEach((items) => {
                if (items.id === item.id) {
                  item.checked = items.checked;
                }
              });
            });
            if (this.configForm.alarmTaskRuleType == "2") {
              this.treeData = this.treeData.filter(
                (item) => item.checked === false
              );
            }
          }
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    queryInWorkGroupOrAccount() {
      if (this.alarmTaskRulePersonList != null) {
        const result = [];
        this.alarmTaskRulePersonList.forEach(function (item) {
          const entity = {};
          entity.id = item.workGroupOrAccount;
          entity.name = item.workGroupOrAccountName;
          entity.checked = true;
          result.push(entity);
        });

        this.selectedList = Object.freeze(result);
      }
    },
    //递归树结构
    menusDataPro(data, init) {
      let _that = this;
      const result = [];
      if (data !== null) {
        if (_that.alarmTaskRuleType == "1") {
          data.forEach(function (item) {
            let flag = false;
            if (init == "init") {
              _that.alarmTaskRulePersonList.every(function (personItem) {
                if (
                  personItem.workGroupOrAccount == item.securityWorkGroupCode
                ) {
                  flag = true;
                  return false;
                } else {
                  return true;
                }
              });
            }
            const entity = {};
            entity.id = item.securityWorkGroupCode;
            entity.name = item.securityWorkGroupName;
            entity.parentCode = item.parentCode;
            entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren;
            entity.checked = false;
            if (flag) {
              entity.checked = true;
            }
            if (item.securityWorkGroupChildren) {
              entity.children = _that.menusDataPro(
                item.securityWorkGroupChildren,
                init
              );
            }
            result.push(entity);
          });
        } else if (_that.alarmTaskRuleType == "2" && data.list != null) {
          data.list.forEach(function (item) {
            let flag = false;
            if (init == "init") {
              _that.alarmTaskRulePersonList.every(function (personItem) {
                if (personItem.workGroupOrAccount == item.accountNumber) {
                  flag = true;
                  return false;
                } else {
                  return true;
                }
              });
            }
            if (!flag) {
              const entity = {};
              entity.id = item.accountNumber;
              entity.name = item.nickName + "(" + item.accountNumber + ")";
              entity.isLeaf = false;
              entity.checked = false;
              result.push(entity);
            }
          });
        } else {
          data.list.forEach(function (item) {
            const entity = {};
            entity.id = item.accountNumber;
            entity.name = item.nickName + "(" + item.accountNumber + ")";
            entity.isLeaf = false;
            entity.checked = false;
            result.push(entity);
          });
        }
      }
      return result;
    },
    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>
      );
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    changeAlarmTaskRule(value) {
      this.alarmTaskRuleType = value;
      this.defaultCheckedKeys = [];
      this.queryOutWorkGroupOrAccount();
    },
    // 移动
    transferWorkGroupOrAccount(type) {
      if (type === "left") {
        // 获取左边未选中的 (左侧列表勾选的)
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          let data = this.selectedList.map((item) => {
            return {
              id: item.id,
              name: item.name,
              checked: true,
            };
          });
          selectedPerson = selectedPerson.map((item) => {
            return {
              id: item.id,
              name: item.name,
              checked: true,
            };
          });
          // 人员根据账号去重
          this.selectedList = this.reduceArr(data, "id");
          this.selectedList.forEach((item) => {
            item.checked = true;
          });
          // 当勾选中后改变左侧树checked的属性值
          this.treeData.forEach((item, index) => {
            this.selectedList.forEach((items) => {
              if (items.id === item.id) {
                item.checked = items.checked;
              }
            });
          });
          this.treeData = this.treeData.filter(
            (item) => item.checked === false
          );
        } else {
          // selectedPerson = this.$refs.tree.getCheckedNodes(true);
        }
      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(
            (item) => item.checked === true
          );
          this.selectedList = this.selectedList.filter(
            (item) => item.checked === false
          );
          this.treeData = this.treeData.concat(rightChoose);
          this.treeData = this.reduceArr(this.treeData, "id");
        } else {
          this.selectedList = [];
        }
      }
    },
    // 根据key对数组对象去重
    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },
    //点击确定按钮,对外暴露已选人员
    submit() {
      if (this.selectedList.length) {
        let chooseIds = [];
        this.selectedList.forEach((item) => {
          chooseIds.push(item.code);
        });
        let params = {
          accountNumberList: chooseIds,
          securityWorkGroupCode: this.workGroupCode,
        };
        this.$fetch(api.addSecurityInfo, params).then((res) => {
          if (res.success) {
            this.$message.success("新增保卫人员成功");
            this.close();
            this.$emit("refreshData");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        this.$message.warning("请选择人员名单");
      }
    },
    close() {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = "";
    },
    // 懒加载节点
    loadNode(node, resolve) {
      if (node.data && node.data.code) {
        let accountGroupCode = node.data.code;
        // 获取当前账户组关联的人员
        this.$fetch(api.reserve.queryAccountGroup, { accountGroupCode }).then(
          (res) => {
            if (res.success) {
              if (res.returnObj && res.returnObj.length) {
                let childrenData = res.returnObj.map((item) => {
                  return {
                    code: item.accountNumber,
                    name: `${item.nickName}(${item.accountNumber})`,
                    isLeaf: true,
                  };
                });
                this.$set(node.data, "children", childrenData);
                resolve(childrenData);
                // this.childrenDataList = childrenData;
              } else {
                return resolve([]);
              }
            } else {
              this.$message.error(res.msgContent);
            }
          }
        );
      } else {
        return resolve([]);
      }
    },
    // 确认弹框
    confirmChoose() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (this.alarmTaskRuleType == "1") {
            // let selectedPerson = this.$refs.workGroupTree.getCheckedNodes();
            // console.log(selectedPerson, this.selectedList, "============");
            // this.selectedList = this.selectedList.concat(selectedPerson);
            // console.log(this.selectedList, "thisstore.selectlisu");
            // let data = this.selectedList.map((item) => {
            //   return {
            //     id: item.id,
            //     name: item.name,
            //     checked: true,
            //   };
            // });
            this.selectedList = this.$refs.workGroupTree
              .getCheckedNodes()
              .map((item) => {
                return {
                  id: item.id,
                  name: item.name,
                  checked: true,
                };
              });
            // 人员根据账号去重
            this.selectedList = this.reduceArr(this.selectedList, "id");
          }
          if (this.selectedList.length) {
            let chooseIds = [];
            this.selectedList.forEach((item) => {
              chooseIds.push(item.id);
            });
            var params = {
              alarmTaskRuleCode: this.alarmTaskRuleCode,
              alarmTaskRuleType: this.configForm.alarmTaskRuleType,
              ruleId: this.ruleId,
              workGroupOrAccountList: chooseIds,
            };
            this.$fetch(api.device.updateAlarmTaskRule, params).then((res) => {
              if (res.success) {
                this.$message({
                  message: "配置成功",
                  type: "success",
                  duration: 2000,
                });
                this.cancleChoose();
                this.$emit("refresh");
              } else {
                this.$message.error(res.msgContent);
              }
            });
          } else {
            this.configForm.alarmTaskRuleType == "1"
              ? this.$message({
                  message: "至少选择一个工作组",
                  type: "warning",
                  duration: 2000,
                })
              : this.$message({
                  message: "至少选择一个安保人员",
                  type: "warning",
                  duration: 2000,
                });
            return false;
            // params = {
            //   // 派发规则编号
            //   alarmTaskRuleCode: this.alarmTaskRuleCode,
            //   // 派发规则类型
            //   alarmTaskRuleType: this.configForm.alarmTaskRuleType,
            //   ruleId: this.ruleId,
            //   workGroupOrAccountList: this.selectedList.map((item) => {
            //     return item.id;
            //   }),
            // };
          }
        }
      });
    },
    // 取消弹框
    cancleChoose() {
      this.configForm = {
        // 派发规则编号
        alarmTaskRuleCode: "",
        // 派发规则类型
        alarmTaskRuleType: "",
      };
      this.selectedList = [];
      this.account = "";
      this.linkDialog = false;
    },
  },
};
</script>
<style lang="scss" >
@import "~@src/common/assets/style/mixin";
.taskRule_wrap {
  .app-panel {
    &__form {
      width: 100%;
      height: 100%;
      padding: 12px;
      position: relative;
    }
  }
  .content-main {
    height: calc(100% - 35px);
    @include set_theme_color(background-color,page-default-bg);
  }
  .scroll-bar {
    height: calc(100% - 50px);
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .groupContent {
    height: calc(100vh - 370px);
    position: relative;
    .content {
      height: 100%;
      width: 100%;
      &-top {
        height: 100%;
        position: relative;
        display: flex;
        align-content: space-around;
        &-left,
        &-right {
          width: calc(100% / 2 - 30px);
          overflow: hidden;
          @include set_theme_color(background-color, main-content-bg-color);
          .group-list {
            height: calc(100vh - 60px);
          }
          .tree-list {
            background: #0d121c !important;
            padding-bottom: 12px;
          }
          .el-tree-node__content {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #181f2e;
          }
          .person-list {
            height: 100%;
            width: 100%;
            padding: 6px 16px 16px;

            .person {
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #181f2e;
            }
            .checked-name {
              margin-left: 10px;
            }
          }
        }
        &-middle {
          width: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-content: center;
          .to-left {
            background: transparent;
            @include set_theme_color(color, active-border-color);
          }
          .to-right {
            background: transparent;
            @include set_theme_color(color, active-border-color);
          }
        }
      }
    }
  }
  .title {
    height: 35px;
    color: #fff;
    font-size: 14px;
    line-height: 35px;
    text-align: center;
    font-weight: normal;
  }
}
</style>
